import logo from "./logo.svg";
import "./App.css";
import TextField from "@mui/material/TextField";

import {
  useJsApiLoader,
  GoogleMap,
  Marker,
  Autocomplete,
  DirectionsRenderer,
} from "@react-google-maps/api";
import { useRef, useState } from "react";

import CircleIcon from "@mui/icons-material/Circle";
import NavigationIcon from "@mui/icons-material/Navigation";
import InputAdornment from "@mui/material/InputAdornment";

import MoreVertIcon from "@mui/icons-material/MoreVert";
import Button from "@mui/material/Button";
import { useFormik } from "formik";
import { useEffect } from "react";
import { createTheme, ThemeProvider, styled } from "@mui/material/styles";
import { orange, red, yellow, green } from "@mui/material/colors";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";

// const center = { lat: 28.7041, lng: 77.1025 };

function App() {
  const [center, setCenter] = useState(null);
  useEffect(() => {
    navigator.geolocation.getCurrentPosition(({ coords }) => {
      setCenter({
        lat: coords.latitude,
        lng: coords.longitude,
      });
    });
  }, []);

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries: ["places"],
  });

  const [map, setMap] = useState(/** @type google.maps.Map */ (null));
  /** @type React.MutableRefObject<HTMLInputElement> */
  const originRef = useRef();
  /** @type React.MutableRefObject<HTMLInputElement> */
  const destiantionRef = useRef();

  const [directionsResponse, setDirectionsResponse] = useState(null);
  const [distance, setDistance] = useState(0);
  const [duration, setDuration] = useState("");

  const loadScript = (src) => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  };

  const theme = createTheme({
    palette: {
      primary: {
        main: green[600],
      },
    },
  });

  useEffect(() => {
    loadScript("https://checkout.razorpay.com/v1/checkout.js");
  });

  if (!isLoaded || !center) {
    return "Loading...";
  }

  async function calculateRoute() {
    console.log(originRef.current, destiantionRef.current);
    if (originRef.current.value === "" || destiantionRef.current.value === "") {
      return;
    }
    // eslint-disable-next-line no-undef
    const directionsService = new google.maps.DirectionsService();
    const results = await directionsService.route({
      origin: originRef.current.value,
      destination: destiantionRef.current.value,
      // eslint-disable-next-line no-undef
      travelMode: google.maps.TravelMode.DRIVING,
    });
    console.log(results.routes[0].legs[0]);
    setDirectionsResponse(results);
    setDistance(results.routes[0].legs[0].distance.value);
    setDuration(results.routes[0].legs[0].duration.text);
  }

  return (
    <ThemeProvider theme={theme}>
      <div className="App">
        <div className="map">
          <GoogleMap
            center={center}
            zoom={15}
            mapContainerStyle={{ width: "100%", height: "100%" }}
            options={{
              zoomControl: false,
              streetViewControl: false,
              mapTypeControl: false,
              fullscreenControl: false,
            }}
            onLoad={(map) => setMap(map)}
          >
            <Marker position={center} />
            {directionsResponse && (
              <DirectionsRenderer directions={directionsResponse} />
            )}
          </GoogleMap>
        </div>
        <LocationFinder originRef={originRef} destiantionRef={destiantionRef} />
        <div className="ride-selector">
          <RideSelect distance={distance} duration={duration} />
        </div>
      </div>
    </ThemeProvider>
  );

  function LocationFinder({ originRef, destiantionRef }) {
    return (
      <div className="location-finder">
        <Autocomplete>
          <TextField
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <CircleIcon color="success" />
                </InputAdornment>
              ),
            }}
            sx={{ width: "400px" }}
            label="Pickup"
            variant="outlined"
            inputRef={originRef}
          />
        </Autocomplete>
        <MoreVertIcon className="connector" />
        <Autocomplete>
          <TextField
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <NavigationIcon
                    color="error"
                    sx={{ transform: "rotate(180deg)" }}
                  />
                </InputAdornment>
              ),
            }}
            sx={{ width: "400px" }}
            label="Drop off"
            variant="outlined"
            inputRef={destiantionRef}
          />
        </Autocomplete>
        <Button
          sx={{ width: "400px" }}
          variant="contained"
          onClick={calculateRoute}
          color="primary"
        >
          Confirm location
        </Button>
      </div>
    );
  }
}

function RideSelect({ duration, distance }) {
  const basePrice = (distance / 1000) * 10;
  const rides = [
    {
      pic: "https://www.olacabs.com/webstatic/img/ola-fleet-svg/ola-mini-active.svg",
      time: duration,
      // price: "₹131",
      description: "Comfy, economical cars",
      type: "Mini",
      multiplier: 5,
      discount: 0,
    },
    {
      pic: "https://www.olacabs.com/webstatic/img/ola-fleet-svg/ola-auto.svg",
      time: duration,
      // price: "₹131",
      description: "Get autos at your doorstep",
      type: "Auto",
      multiplier: 4,
      discount: 0,
    },
    {
      pic: "https://www.olacabs.com/webstatic/img/ola-fleet-svg/ola-prime-play-active.svg",
      time: duration,
      // price: "₹131",
      description: "Music, movies, TV and more",
      type: "Prime Play",
      multiplier: 6,
      discount: 5,
    },

    {
      pic: "https://www.olacabs.com/webstatic/img/ola-fleet-svg/ola-prime-sedan-active.svg",
      time: duration,
      // price: "₹131",
      description: "Spacious sedans, top drivers",
      type: "Prime Sedan",
      multiplier: 5.5,
      discount: 5,
    },
    {
      pic: "https://www.olacabs.com/webstatic/img/ola-fleet-svg/ola-bike-active.svg",
      time: duration,
      // price: "₹131",
      description: "Beat the traffic on a bike",
      type: "Bike",
      multiplier: 2,
      discount: 4,
    },
    {
      pic: "https://www.olacabs.com/webstatic/img/ola-fleet-svg/ola-prime-suv-active.svg",
      time: duration,
      // price: "₹131",
      description: "Spacious SUVs",
      type: "Prime Suv",
      multiplier: 8,
      discount: 0,
    },
  ];

  const [open, setOpen] = useState(false);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  function displayRazorpay(amout) {
    const options = {
      key: process.env.REACT_APP_RAZOR_PAY_KEY,
      currency: "INR",
      amount: amout * 100,
      name: "ArkZoro",
      description: "ArkZoro cabs",
      image: "",
      handler: function (response) {
        console.log("PAYMENT ID ::", response.razorpay_payment_id);
        setOpen(true);
      },
      prefill: {
        name: "Anirudh Jwala",
        email: "anirudh@gmail.com",
        contact: "9999999999",
      },
    };

    const paymentObject = new window.Razorpay(options);
    paymentObject.open();
  }

  if (!duration || !distance) {
    return null;
  }

  return (
    <>
      {/* <Snackbar
        open={open}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        autoHideDuration={2000}
        onClose={handleClose}
      >
        <Alert severity="success">
          <AlertTitle>Success</AlertTitle>
          Booking <strong>Confirmed</strong>
        </Alert>
      </Snackbar> */}

      <div className="ride-container">
        {rides.map((ride) => (
          <div
            className="ride"
            onClick={() =>
              displayRazorpay(
                Math.round(
                  basePrice * ride.multiplier * (1 - ride.discount / 100)
                )
              )
            }
          >
            <div className="ride-group">
              <img src={ride.pic} alt={ride.type} className="ride-pic" />
              <p className="ride-time">{ride.time}</p>
            </div>
            <div className="ride-group">
              <h3 className="ride-type">{ride.type}</h3>
              <p className="ride-description">{ride.description}</p>
            </div>
            <div className="ride-group">
              <h3 className="ride-price">
                ₹
                {Math.round(
                  basePrice * ride.multiplier * (1 - ride.discount / 100)
                )}
              </h3>
              {ride.discount ? (
                <p className="ride-discount">
                  ₹{Math.round(basePrice * ride.multiplier)}
                </p>
              ) : null}
            </div>
          </div>
        ))}
      </div>
    </>
  );
}

export default App;
